import React, { useState } from 'react';
import Button from '../base/Button';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navItems = [
    { label: 'Portfolio', href: '/portfolio' },
    { label: 'AIPAI Index', href: '/aipai-index' },
    { label: 'News', href: '/news' },
    { label: 'PAI Capital', href: '/pai-capital' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1 className="m-0">
              <a href="/" className="text-xl font-bold transition-colors duration-300 text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                Palo Alto Innovate
              </a>
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="/portfolio" className="font-medium transition-colors duration-300 hover:text-red-500 text-gray-700">
              Portfolio
            </a>
            <a href="/aipai-index" className="font-medium transition-colors duration-300 hover:text-red-500 text-gray-700">
              AIPAI Index
            </a>
            <a href="/pai-capital" className="font-medium transition-colors duration-300 hover:text-red-500 text-gray-700">
              PAI Capital
            </a>
            <a href="/news" className="font-medium transition-colors duration-300 hover:text-red-500 text-gray-700">
              News
            </a>
            <Button variant="primary" size="sm">
              Contact Us
            </Button>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="p-2 rounded-md transition-colors duration-300 text-gray-700 hover:bg-gray-100"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-2 space-y-1">
            <a href="/portfolio" className="block px-3 py-2 text-gray-700 hover:text-red-500 hover:bg-gray-50 rounded-md">
              Portfolio
            </a>
            <a href="/aipai-index" className="block px-3 py-2 text-gray-700 hover:text-red-500 hover:bg-gray-50 rounded-md">
              AIPAI Index
            </a>
            <a href="/pai-capital" className="block px-3 py-2 text-gray-700 hover:text-red-500 hover:bg-gray-50 rounded-md">
              PAI Capital
            </a>
            <a href="/news" className="block px-3 py-2 text-gray-700 hover:text-red-500 hover:bg-gray-50 rounded-md">
              News
            </a>
            <div className="px-3 py-2">
              <Button variant="primary" size="sm" className="w-full">
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
